<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span>{{ $t('api.contact.data') }}</span>
    </div>
    <el-card class="box-card"
      v-for="cData in formData.contact"
      :key="cData.id">
      <div slot="header" class="clearfix">
        <svg-icon icon-class="baseline-person-24px"></svg-icon>
        <span>{{ cData.name }}</span>
      </div>
      <el-row :gutter="20">
        <el-col :xs="24" :md="18">
          <el-tag v-if="cData.email">
            <i class="el-icon-message"></i>
            {{ cData.email }}
          </el-tag>
          <el-tag v-if="cData.phone">
            <i class="el-icon-phone"></i>
            {{ cData.phone }}
          </el-tag>
          <el-tag v-if="cData.mobile">
            <svg-icon icon-class="baseline-smartphone-24px"></svg-icon>
            {{ cData.mobile }}
          </el-tag>
        </el-col>
        <el-col :xs="24" :md="6">
          <el-button type="primary" icon="el-icon-edit"
            @click="contVis = true; contData.id = cData.id">
          </el-button>
          <el-button type="danger" icon="el-icon-delete"
            @click="delContact(cData.id, cData.name)">
          </el-button>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="cData.note">
        <el-col>
          <el-collapse>
            <el-collapse-item :name="cData.id">
              <template #title>
                <span>{{ $t('api.contact.fields.note.label') }}</span>
              </template>
              <div class="pre-wrap-text">{{ cData.note }}</div>
            </el-collapse-item>
          </el-collapse>
        </el-col>
      </el-row>
    </el-card>
    <el-form-item>
      <el-button type="primary" @click="contVis = true; contData.id = undefined">
        <i class="el-icon-plus"></i>
        {{ transText('contact.create') }}
      </el-button>
    </el-form-item>
    <el-dialog
      :title="transText(contData.id ? 'contact.editBtn' : 'contact.create')"
      :visible.sync="contVis"
      @open="showContDialog"
      custom-class="rwd-dialog"
      >
      <el-form
        label-position="top"
        :model="contData"
        ref="contact"
        >
        <base-field
          v-if="contData.id"
          base="contact"
          :formData="contData"
          >
        </base-field>
        <el-row :gutter="20">
          <el-col :xs="24" :md="12">
            <text-field
              v-model="contData.name"
              :maxlength="128"
              base="contact"
              name="name"
              :required="true"
              >
            </text-field>
          </el-col>
          <el-col :xs="24" :md="12">
            <text-field
              v-model="contData.email"
              :maxlength="128"
              :base="base"
              name="email"
              >
            </text-field>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xs="24" :md="12">
            <text-field
              v-model="contData.phone"
              :maxlength="32"
              :base="base"
              name="phone"
              :hasDesc="true"
              :rules="{ validator: validatePhone, trigger: 'blur' }"
              >
            </text-field>
          </el-col>
          <el-col :xs="24" :md="12">
            <text-field
              v-model="contData.mobile"
              :maxlength="32"
              :base="base"
              name="mobile"
              type="email"
              :hasDesc="true"
              :rules="{ validator: validatePhone, trigger: 'blur' }"
              >
            </text-field>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xs="24" :md="6">
            <text-field
              v-model="contData.zip"
              :maxlength="16"
              :base="base"
              name="zip"
              >
            </text-field>
          </el-col>
          <el-col :xs="24" :md="18">
            <text-field
              v-model="contData.address"
              :maxlength="255"
              :base="base"
              name="address"
              >
            </text-field>
          </el-col>
        </el-row>
        <text-field
          v-model="contData.note"
          :base="base"
          type="textarea"
          name="note"
          >
        </text-field>
        <el-button
          v-show="false"
          type="primary"
          native-type="submit"
          @click.native.prevent="saveCont"
          >
          {{ $t('api.saveBtn') }}
        </el-button>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          @click="contVis = false"
          >
          {{ $t('api.cancelBtn') }}
        </el-button>
        <el-button
          type="primary"
          @click="saveCont"
          :loading="contLoading"
          >
          {{ $t('api.saveBtn') }}
        </el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>

import { transText } from '@/utils/i18n'
import { fetchOne, updateOne, create, deleteOne } from '@/api/merchant/contact'

const defContData = {
  id: undefined,
  name: '',
  phone: '',
  mobile: '',
  email: '',
  zip: '',
  address: '',
  note: '',
  merchant: [],
  branch: [],
  created_at: undefined,
  updated_at: undefined
}

export default {
  name: 'contact-manager',
  props: {
    type: {
      type: String,
      default: 'merchant'
    },
    formData: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      base: 'contact',
      contVis: false,
      contLoading: false,
      contData: Object.assign({}, defContData)
    }
  },
  methods: {
    transText,
    validatePhone (rule, value, callback) {
      if (this.contData.mobile === '' && this.contData.phone === '') {
        callback(new Error(this.$t('api.contact.fields.phone.desc')))
      } else {
        callback()
      }
    },
    showContDialog () {
      this.$nextTick(() => {
        this.$refs.contact.clearValidate()
      })
      if (this.contData.id) {
        fetchOne(this.contData.id).then(response => {
          this.contData = response.data
        }).catch(err => {
          console.log(err)
        })
      } else {
        this.contData = JSON.parse(JSON.stringify(defContData))
      }
    },
    saveCont () {
      this.$refs.contact.validate(valid => {
        if (!valid) {
          return false
        }
        this.contLoading = true
        if (this.type === 'branch') {
          if (this.formData.bid) {
            this.contData.branch = [{
              bid: this.formData.bid
            }]
          }
        } else {
          if (this.formData.id) {
            this.contData[this.type] = [{
              id: this.formData.id
            }]
          }
        }
        if (this.contData.id) {
          updateOne(this.contData.id, this.contData).then(response => {
            this.$message({
              message: this.transText('contact.editSuccess'),
              type: 'success',
              duration: 2000
            })
            this.formData.contact = this.formData.contact.map(
              (item) => {
                return item.id === this.contData.id ? response.data : item
              }
            )
            this.contVis = false
          }).catch(err => {
            console.log(err)
          }).then(() => {
            this.contLoading = false
          })
        } else {
          create(this.contData).then(response => {
            this.$message({
              message: this.transText('contact.addSuccess'),
              type: 'success',
              duration: 2000
            })
            this.formData.contact.push(response.data)
            this.contVis = false
          }).catch(err => {
            console.log(err)
          }).then(() => {
            this.contLoading = false
          })
        }
      })
    },
    delContact (id, name) {
      this.$confirm(this.$t('api.delConfirmMsg', {
        id: id,
        name: name,
        idText: this.transText('contact.id'),
        dataText: this.transText('contact.name')
      }), this.$t('api.delConfirmTitle'), {
        confirmButtonText: this.$t('api.confirmBtn'),
        cancelButtonText: this.$t('api.cancelBtn'),
        confirmButtonClass: 'el-button--danger',
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        deleteOne(id).then(response => {
          this.$message({
            message: this.transText('contact.delSuccess'),
            type: 'success',
            duration: 2000
          })
          this.formData.contact = this.formData.contact.filter(e => e.id !== id)
        }).catch(err => {
          console.log(err)
        })
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>
